import React, { useEffect, useState } from 'react';

import { useQuery } from "react-query";

import { fetchFMCPFileExist } from 'utils/ts-queries';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import DescriptionIcon from '@mui/icons-material/Description';

type Props = {
  reclamationId: number;
};

export default function ReclamationFichierFMCP({reclamationId} : Props) {

  const { isLoading, isError, data } =
      useQuery({
          queryKey: [
              'check-reclamation-fmcp-file-exist',
              reclamationId
          ],
          queryFn: () => fetchFMCPFileExist({
              reclamationId
          }),
          cacheTime: 3000,
          retry: false
      })


  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 1 }}>
        <CircularProgress size={20} />
      </Box>
    );
  }


  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      bgcolor: data ? 'primary.main' : 'secondary.main', 
      color: 'primary.contrastText',
      p: 1,
      borderRadius: 1
    }}>
      <DescriptionIcon sx={{ mr: 1 }} />
      <Typography variant="body2">FMCP</Typography>
    </Box>
  );
}